<template>
    <div :id="pieID == 1 ? 'pieID' : pieID == 2 ? 'pieID2' : pieID == 3 ? 'pieID3' : 'pieID1'" :option="option">
    </div>
</template>
<script>
export default {
    props: {
		  option: {
			type: Object,
			default: () => {},
		},
        pieID: [String, Number], //ID
		isreload:[String, Number]
		},
    data() {
        return {
            chartsDom:''
        }
    },
    watch: {
			 option: {
			handler(newVal, oldVal) {
			  if (this.chartsDom ) {
			  if (newVal) {
				this.chartsDom.setOption(newVal);
			  } else {
				this.chartsDom.setOption(oldVal);
			  }
			  }else{
				  this.init()
			  }
			},
			deep: true
			},
	},
    created () {
    },
	mounted () {
		if(this.isreload){
			 this.init()	
		}
	},
    methods: {
            init() {			
                let getId = this.pieID == 1 ? 'pieID' : this.pieID == 2 ? 'pieID2' : this.pieID == 3 ? 'pieID3' : 'pieID1'
                let chartsDom = this.$echarts.init(document.getElementById(getId));
                this.chartsDom = chartsDom
				this.chartsDom.setOption(this.option);
				window.addEventListener("resize", function() {
					chartsDom.resize();
				});
            },
    },
    beforeDestroy(){
			 window.removeEventListener("resize",function() {
					this.chartsDom.resize();
				});
		},
}
</script>
<style lang="scss" scoped>
#pieID{
    height: 390px;
    margin-top: 30px;
}
#pieID1{
    height: 390px;
    margin-top: 30px;
}
#pieID2,#pieID3{
    height: 200px;
    margin-top: 30px;
}
</style>